import { Box, Button, Card, Container, Grid, IconButton, Typography, Chip } from '@mui/material';
import Page from '../components/Page';
import { useEffect, useState, useRef } from 'react';
import config from '../config.json';
import api from '../api';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import backIcon from '@iconify/icons-ant-design/arrow-left-outline';
import { Icon } from '@iconify/react';
import { useNavigate } from "react-router-dom";
import ReactionFooter from "../components/ReactionFooter";
import ProgressBar from "../components/ProgressBar";
import { shuffle } from "../utils/array";
import './SentenceStructure.css';

export default function SentenceStructure() {
  const [sentences, setSentences] = useState([]);
  const [currentSentence, setCurrentSentence] = useState(null);
  const [availableWords, setAvailableWords] = useState([]);
  const [selectedWords, setSelectedWords] = useState([]);
  const [usedIndices, setUsedIndices] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(-1);
  const [index, setIndex] = useState(0);
  const [complete, setComplete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [wrongWordIndex, setWrongWordIndex] = useState(-1);
  const audioCtxRef = useRef(null);
  
  let { wordlist_id } = useParams();
  let navigate = useNavigate();

  const getAudioContext = () => {
    if (!audioCtxRef.current) {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (AudioCtx) {
        audioCtxRef.current = new AudioCtx();
      }
    }
    return audioCtxRef.current;
  }

  // Bitta yumshoq nota chalish (sinus to'lqin + yumshoq kirish/chiqish)
  const playTone = (ctx, frequency, startTime, duration, peakGain) => {
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(frequency, startTime);

    // Yumshoq envelope - "click" ovozisiz, quloqqa yoqimli
    gainNode.gain.setValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(peakGain, startTime + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.start(startTime);
    oscillator.stop(startTime + duration);
  }

  // To'g'ri javob - ko'tariluvchi yoqimli akkord (C5 -> E5 -> G5)
  const playSuccessSound = () => {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume();

    const now = ctx.currentTime;
    playTone(ctx, 523.25, now, 0.18, 0.18);       // C5
    playTone(ctx, 659.25, now + 0.11, 0.18, 0.18); // E5
    playTone(ctx, 783.99, now + 0.22, 0.30, 0.20); // G5
  }

  // Xato javob - yumshoq pastga tushuvchi ohang (quloqni bezovta qilmaydi)
  const playErrorSound = () => {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume();

    const now = ctx.currentTime;
    playTone(ctx, 392.00, now, 0.22, 0.16);        // G4
    playTone(ctx, 311.13, now + 0.15, 0.34, 0.16); // Eb4
  }

  const loadDataAPI = () => {
    axios.get(config.apiUrl + '/sentence-structure/get', {
      headers: {
        'Authorization': api.getToken()
      },
      params: {
        wordlist_id: wordlist_id
      }
    }).then((response) => {
      if (response.data.success) {
        setIndex(0);
        setErrorCount(0);
        setSuccessCount(0);
        setComplete(false);
        setStatus(0);
        setMessage('');
        setIsChecked(false);
        setSelectedWords([]);
        setUsedIndices([]);
        setWrongWordIndex(-1);

        let data = response.data.data;
        setSentences(data);
        setTotalCount(data.length);

        if (data.length > 0) {
          setupSentence(data[0]);
        }
      }
    }).catch((error) => {
      if (error.response != undefined) {
        if (error.response.status == 401) {
          api.logOut();
        } else {
          alert(error.response.data.message);
        }
      }
    });
  }

  const setupSentence = (sentence) => {
    setCurrentSentence(sentence);
    
    // Inglizcha gapni so'zlarga ajratish
    let words = sentence.en.split(' ');
    
    // So'zlarni aralashtirib berish
    setAvailableWords(shuffle([...words]));
    setSelectedWords([]);
    setUsedIndices([]);
  }

  useEffect(() => {
    loadDataAPI();
  }, []);

  const handleWordClick = (word, wordIndex) => {
    if (isChecked) return;
    if (usedIndices.includes(wordIndex)) return;

    // So'zni tanlanganlar qatoriga qo'shamiz, asl joyi esa bo'sh qoladi
    setSelectedWords([...selectedWords, { word, srcIndex: wordIndex }]);
    setUsedIndices([...usedIndices, wordIndex]);
  }

  const handleSelectedWordClick = (item, selectedIndex) => {
    // Faqat tekshirilmagan holatda so'zlarni qaytarish mumkin
    if (!isChecked) {
      setSelectedWords(selectedWords.filter((_, idx) => idx !== selectedIndex));
      setUsedIndices(usedIndices.filter((srcIdx) => srcIdx !== item.srcIndex));
    }
  }

  const handleDragStart = (dragIndex) => {
    if (isChecked) return;
    setDraggedIndex(dragIndex);
  }

  const handleDragOver = (event, overIndex) => {
    if (isChecked || draggedIndex === -1 || draggedIndex === overIndex) return;
    event.preventDefault();

    // Sudralayotgan so'zni yangi joyga ko'chiramiz
    let reordered = [...selectedWords];
    let [moved] = reordered.splice(draggedIndex, 1);
    reordered.splice(overIndex, 0, moved);
    setSelectedWords(reordered);
    setDraggedIndex(overIndex);
  }

  const handleDragEnd = () => {
    setDraggedIndex(-1);
  }

  const checkAnswer = () => {
    if (selectedWords.length === 0) return;

    if (!isChecked) {
      // Tekshirish
      let userAnswer = selectedWords.map((item) => item.word).join(' ').toLowerCase().trim();
      let correctAnswer = currentSentence.en.toLowerCase().trim();

      if (userAnswer === correctAnswer) {
        // To'g'ri javob
        setStatus(1);
        setMessage('');
        setSuccessCount(successCount + 1);
        setIsChecked(true);

        // To'g'ri javob ovozi
        playSuccessSound();

        // Serverga yuborish
        sendResultToServer(1);
      } else {
        // Xato javob
        setStatus(-1);
        setMessage('');
        setErrorCount(errorCount + 1);
        setIsChecked(true);

        // Xato javob ovozi
        playErrorSound();

        // Serverga yuborish
        sendResultToServer(-1);
      }
    } else {
      // Keyingi savolga o'tish (faqat to'g'ri javob bo'lganda yoki xato bo'lsa ham keyingisiga o'tish)
      let nextIndex = index + 1;
      if (nextIndex >= sentences.length) {
        setComplete(true);
      } else {
        setIndex(nextIndex);
        setupSentence(sentences[nextIndex]);
        setStatus(0);
        setMessage('');
        setIsChecked(false);
        setWrongWordIndex(-1);
      }
    }
  }

  const sendResultToServer = (point) => {
    axios.post(config.apiUrl + '/sentence-structure/action',
      {
        sentence_id: currentSentence.sentence_id,
        word_id: currentSentence.word_id,
        point: point
      },
      {
        headers: {
          'Authorization': api.getToken()
        }
      }
    ).then((response) => {
      if (response.data.success) {
        // Ma'lumot butun mashq tugagach (complete) yangilanadi — quyidagi useEffect'da.
      }
    }).catch((error) => {
      if (error.response != undefined) {
        if (error.response.status == 401) {
          api.logOut();
        }
      }
    });
  }

  const keyDownHandler = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (complete) {
        loadDataAPI();
      } else {
        checkAnswer();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [complete, isChecked, selectedWords]);

  // Mashq to'liq tugagach user ma'lumotini (faol kunlar / streak) bir marta yangilaymiz.
  useEffect(() => {
    if (complete){
      api.updateUserData();
    }
  }, [complete]);

  return (
    <Page title="Sentence Structure | eagles.uz">
      <Container maxWidth="md">
        <IconButton aria-label="fingerprint" color="success" onClick={() => navigate(-1)}>
          <Icon icon={backIcon} width={24} height={24} />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item sm={12} xs={12}>
            {
              complete === false ?
                <>
                  <Box sx={{ py: 2 }}>
                    <ProgressBar current={index} total={sentences.length} />
                  </Box>

                  {currentSentence && (
                    <Box sx={{ maxWidth: '700px', margin: '0 auto' }}>
                      {/* O'zbekcha gap */}
                      <Box sx={{ py: 2, mb: 1 }}>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1.5, fontSize: '0.875rem' }}>
                          Translate this sentence:
                        </Typography>
                        <Card 
                          sx={{ 
                            p: 2.5, 
                            mb: 2, 
                            backgroundColor: '#f8f9fa',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                            border: '1px solid #e9ecef',
                            borderRadius: '12px'
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography variant="h5" sx={{ fontWeight: 500, flex: 1 }}>
                              {currentSentence.uz}
                            </Typography>
                          </Box>
                        </Card>
                      </Box>

                      {/* Tanlangan so'zlar maydoni */}
                      <Box sx={{ py: 1, mb: 2 }}>
                        <Card 
                          sx={{ 
                            p: 2.5, 
                            minHeight: '80px',
                            backgroundColor: '#ffffff',
                            border: status === 1 ? '3px solid #4caf50' : status === -1 ? '3px solid #f44336' : '2px dashed #bdbdbd',
                            borderRadius: '12px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.3s ease',
                            boxShadow: status === 1 ? '0 4px 12px rgba(76, 175, 80, 0.2)' : status === -1 ? '0 4px 12px rgba(244, 67, 54, 0.2)' : 'inset 0 2px 4px rgba(0,0,0,0.06)'
                          }}
                          className={status === 1 ? 'shake-success' : status === -1 ? 'shake-error' : ''}
                        >
                          {selectedWords.length === 0 ? (
                            <Box sx={{ textAlign: 'center', py: 1 }}>
                              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                Select words to build the sentence...
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                                {currentSentence.en.split(' ').map((_, idx) => (
                                  <Box 
                                    key={idx} 
                                    sx={{ 
                                      width: '60px', 
                                      height: '8px', 
                                      backgroundColor: '#e0e0e0',
                                      borderRadius: '4px'
                                    }} 
                                  />
                                ))}
                              </Box>
                            </Box>
                          ) : (
                            selectedWords.map((item, idx) => (
                              <Chip
                                key={idx}
                                label={item.word}
                                onClick={() => handleSelectedWordClick(item, idx)}
                                draggable={!isChecked}
                                onDragStart={() => handleDragStart(idx)}
                                onDragOver={(e) => handleDragOver(e, idx)}
                                onDragEnd={handleDragEnd}
                                sx={{
                                  fontSize: '1.1rem',
                                  padding: '22px 10px',
                                  backgroundColor: isChecked && status === -1 ? '#ffebee' : '#e3f2fd',
                                  border: isChecked && status === -1 ? '2px solid #f44336' : '2px solid #90caf9',
                                  borderRadius: '10px',
                                  fontWeight: 500,
                                  cursor: !isChecked ? (draggedIndex === idx ? 'grabbing' : 'grab') : 'default',
                                  opacity: draggedIndex === idx ? 0.4 : 1,
                                  transition: 'all 0.2s ease',
                                  pointerEvents: isChecked ? 'none' : 'auto',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                                  '&:hover': {
                                    transform: !isChecked ? 'translateY(-3px)' : 'none',
                                    boxShadow: !isChecked ? '0 4px 12px rgba(0,0,0,0.18)' : '0 2px 6px rgba(0,0,0,0.12)',
                                    backgroundColor: !isChecked ? '#bbdefb' : '#e3f2fd'
                                  },
                                  '&:active': {
                                    transform: !isChecked ? 'scale(0.97)' : 'none'
                                  }
                                }}
                              />
                            ))
                          )}
                        </Card>
                      </Box>

                      {/* Xato bo'lganda to'g'ri javobni ko'rsatish */}
                      {isChecked && status === -1 && (
                        <Box sx={{ py: 2, mb: 2 }}>
                          <Card 
                            sx={{ 
                              p: 2.5, 
                              backgroundColor: '#ffffff',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              animation: 'fadeIn 0.4s ease-in'
                            }}
                          >
                            <Typography 
                              variant="body2" 
                              color="textSecondary" 
                              sx={{ mb: 1.5, fontSize: '0.875rem', textAlign: 'center' }}
                            >
                              Correct answer:
                            </Typography>
                            <Box 
                              sx={{ 
                                display: 'flex', 
                                flexWrap: 'wrap', 
                                gap: 1.5,
                                justifyContent: 'center'
                              }}
                            >
                              {currentSentence.en.split(' ').map((word, idx) => (
                                <Chip
                                  key={idx}
                                  label={word}
                                  sx={{
                                    fontSize: '1.1rem',
                                    padding: '22px 10px',
                                    backgroundColor: '#c8e6c9',
                                    border: '2px solid #66bb6a',
                                    borderRadius: '10px',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 6px rgba(102, 187, 106, 0.3)',
                                    pointerEvents: 'none'
                                  }}
                                />
                              ))}
                            </Box>
                          </Card>
                        </Box>
                      )}

                      {/* Mavjud so'zlar - faqat tekshirilmagan holatda ko'rsatish */}
                      {!isChecked && (
                        <Box sx={{ py: 1, mb: 2 }}>
                          <Box 
                            sx={{ 
                              display: 'flex', 
                              flexWrap: 'wrap', 
                              gap: 1.5,
                              justifyContent: 'center',
                              p: 1.5
                            }}
                          >
                            {availableWords.map((word, idx) => (
                              usedIndices.includes(idx) ? (
                                <Chip
                                  key={idx}
                                  label={word}
                                  sx={{
                                    fontSize: '1.1rem',
                                    padding: '22px 10px',
                                    borderRadius: '10px',
                                    fontWeight: 500,
                                    backgroundColor: '#fafafa',
                                    border: '2px dashed #cfcfcf',
                                    boxShadow: 'none',
                                    color: 'transparent',
                                    cursor: 'default',
                                    pointerEvents: 'none'
                                  }}
                                />
                              ) : (
                                <Chip
                                  key={idx}
                                  label={word}
                                  onClick={() => handleWordClick(word, idx)}
                                  sx={{
                                    fontSize: '1.1rem',
                                    padding: '22px 10px',
                                    backgroundColor: '#fff',
                                    border: '2px solid #1976d2',
                                    borderRadius: '10px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 3px 8px rgba(25, 118, 210, 0.15)',
                                    '&:hover': {
                                      transform: 'translateY(-4px) scale(1.02)',
                                      boxShadow: '0 6px 16px rgba(25, 118, 210, 0.3)',
                                      backgroundColor: '#e3f2fd',
                                      borderColor: '#1565c0'
                                    },
                                    '&:active': {
                                      transform: 'scale(0.97)'
                                    }
                                  }}
                                />
                              )
                            ))}
                          </Box>
                        </Box>
                      )}

                      {/* Check/Continue tugmasi */}
                      <Box sx={{ py: 2, textAlign: 'center' }}>
                        <Button 
                          size="large" 
                          variant="contained" 
                          fullWidth
                          disabled={selectedWords.length === 0 && !isChecked}
                          onClick={checkAnswer}
                          sx={{ 
                            py: 2,
                            fontSize: '1.1rem',
                            fontWeight: 600,
                            borderRadius: '12px',
                            textTransform: 'none',
                            boxShadow: selectedWords.length > 0 || isChecked ? '0 4px 12px rgba(25, 118, 210, 0.3)' : 'none',
                            backgroundColor: 
                              selectedWords.length === 0 && !isChecked ? '#e0e0e0' : 
                              status === 1 ? '#4caf50' : 
                              status === -1 ? '#f44336' : 
                              '#1976d2',
                            '&:hover': {
                              backgroundColor: 
                                selectedWords.length === 0 && !isChecked ? '#e0e0e0' :
                                status === 1 ? '#45a049' : 
                                status === -1 ? '#da190b' : 
                                '#1565c0',
                              boxShadow: selectedWords.length > 0 || isChecked ? '0 6px 16px rgba(25, 118, 210, 0.4)' : 'none'
                            },
                            '&:disabled': {
                              backgroundColor: '#e0e0e0',
                              color: '#9e9e9e'
                            },
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {!isChecked ? 'Check' : 'Continue'}
                        </Button>
                      </Box>
                    </Box>
                  )}
                </>
                :
                <>
                  <center>
                    <Box 
                      sx={{ 
                        py: 5,
                        animation: 'fadeIn 0.5s ease-in'
                      }}
                    >
                      <Typography variant="h3" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                        Congratulations! 🎉
                      </Typography>
                      <Card sx={{ p: 4, maxWidth: 400, mx: 'auto', mt: 3, borderRadius: '16px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}>
                        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                          Results
                        </Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6}>
                            <Box sx={{ textAlign: 'center' }}>
                              <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
                                Success
                              </Typography>
                              <Typography variant="h3" sx={{ color: '#4caf50', fontWeight: 700 }}>
                                {successCount}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box sx={{ textAlign: 'center' }}>
                              <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
                                Errors
                              </Typography>
                              <Typography variant="h3" sx={{ color: '#f44336', fontWeight: 700 }}>
                                {errorCount}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Card>
                      <Button 
                        size="large" 
                        sx={{ 
                          mt: 4, 
                          px: 6, 
                          py: 2,
                          fontSize: '1.1rem',
                          fontWeight: 600,
                          borderRadius: '12px',
                          textTransform: 'none',
                          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                        }} 
                        variant="contained" 
                        onClick={loadDataAPI}
                      >
                        Restart
                      </Button>
                    </Box>
                  </center>
                </>
            }
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
